module.exports = __webpack_public_path__ + "img/icon_device.84d1fc00.svg";